import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0};
    }
  },
});

router.afterEach((to) => {
  // Sends a message to vuex to recalculate the active navigation step
  router.app.$store?.dispatch('projectOne/updateActiveNavigationStep', to?.name);
});

export default router;
